import script from "./CoachingSessionLoadingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoachingSessionLoadingView.vue?vue&type=script&lang=ts&setup=true"

import "./CoachingSessionLoadingView.vue?vue&type=style&index=0&id=490b61e4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490b61e4"]])

export default __exports__